/** Event */
export default {
  create: '생성 중',
  createProgramme: 'AI 프로그램 생성',
  aiProgramme: 'AI 프로그램',
  name: '활동 이름',
  placeholder: '활동 이름 입력',
  total: '총 등록 수',
  likes: '총 좋아요 수',
  income: '총 등록 수입',
  tips: {
    total: '신청자 수는 취소를 포함하지 않습니다',
    income: '수입은 환불, 보상 및 제품 판매를 포함하지 않습니다'
  },
  table: {
    name: '활동 이름',
    status: '활동 상태',
    total: '총 등록 수',
    today: '오늘의 등록 수',
    last_week: '지난 주 등록 수',
    create: '생성 시간',
    update: '업데이트 시간',
    start: '시작 시간',
    end: '종료 시간',
    operate: '작업',
    oper: {
      data: '등록 데이터',
      config: '콘텐츠 설정',
      progress: '진행 설정',
      display: '활동 표시',
      screen: '데이터 화면',
      share: '활동 공유',
      more: '더 많은 기능',
      mores: {
        setting: '표시 설정',
        ad: '광고 설정',
        live: '이미지 라이브 방송',
        video: '비디오 하이라이트',
        qrcode: '체크인 QR 코드',
        gift: '선물과 상품'
      }
    },
    total_number: '총 {total}개 항목'
  },
  create_form: {
    placeholder: '입력해 주세요',
    status: {
      '是否确认立刻发布活动?': '활동을 즉시 발표하시겠습니까?'
    },
    content: {
      title: '활동 내용',
      name: {
        label: '활동 이름',
        hover: '이 활동의 이름, 예: 제1회 어린이 그림 전시회'
      },
      cycle: {
        label: '활동 기간',
        hover: '전체 활동 시간, 시작부터 종료까지: 예: 2024.01.20 ~ 2024.05.20; 미정인 경우 예상 기간을 입력하세요'
      },
      stage: {
        title: '활동 단계',
        desc: '현재는 한 단계만 생성할 수 있습니다. 더 추가하려면 초기 설정을 완료한 후 활동 목록에서 "고급 설정"을 사용하세요.',
        name: {
          title: '단계 이름',
          hover: '활동 단계의 이름. 현재는 한 단계만 설정 가능; 예: 1차전, 2차전, 오디션, 결선'
        },
        start: {
          title: '등록 시간',
          hover: '이 단계의 등록 시작 시간과 종료 시간, 분과 초까지 정확하게 입력하세요. 참고: 등록 기간 외에는 등록이 불가능합니다; 미정인 경우 나중에 입력할 수 있습니다'
        },
        hold: {
          title: '개최 시간',
          hover: '이 단계의 시작 시간과 종료 시간, 분과 초까지 정확하게 입력하세요. 예: 오프라인 전시 기간 또는 시상식 기간; 미정인 경우 나중에 입력할 수 있습니다'
        }
      },
      poster: {
        title: '활동 포스터',
        upload: '클릭하여 업로드',
        tips: {
          _1: '팁: .jpg, .png 이미지 형식 지원; 최대 이미지 용량은 5MB를 초과할 수 없음; 이미지 크기 비율은 1:1로 유지하는 것이 좋으며, 최소 크기는 860px*860px',
          _2: '이미지는 신청자 페이지 상단에 표시됩니다, 클릭하여 예시 보기'
        }
      },
      detail: {
        desc: '신청자에게 표시됨, 클릭하여 예시 보기',
        placeholder: '입력해 주세요',
        title: {
          _1: '활동 소개',
          _2: '등록 규칙',
          _3: '조직'
        }
      }
    },
    group: {
      title: '그룹 정보',
      desc: '현재는 하나의 그룹 활동만 설정할 수 있습니다. 여러 다른 그룹 활동이 있는 경우, 먼저 활동의 초기 생성을 완료한 후 활동 목록에서 해당 활동의 "활동 설정 - 하위 대회 설정"을 클릭하여 설정하세요. 활동 시스템은 다른 그룹 활동에 대해 다른 등록비, 등록 양식, 기본 선정, 등록 양식 및 기타 설정을 할 수 있도록 지원합니다',
      category: {
        title: '활동',
        hover: '예: 미술; 무용;',
        add: '카테고리 추가',
        name: '카테고리 이름'
      },
      group: {
        title: '활동 그룹',
        hover: '예: 청소년 그룹; 성인 그룹;',
        add: '그룹 추가',
        name: '그룹 이름'
      },
      form: {
        title: '등록 양식',
        hover: '신청자가 작성해야 하는 정보 내용; 다른 카테고리나 그룹은 다른 등록 양식을 사용할 수 있습니다',
        create: '활동 등록 정보 생성'
      },
      charge: {
        title: '등록비',
        hover: '다른 카테고리나 그룹에 대해 다른 비용을 설정할 수 있습니다'
      },
      config: {
        title: '상세 설정:',
        hover: '다른 카테고리나 그룹에 대해 다른 선정 규칙, 선정 기준, 선정 방법, 선정 수, 선정 결과 발표 시간 등을 설정할 수 있습니다',
        repeat: {
          title: '동일 그룹의 반복 등록:',
          hover: '그룹 활동에서 사용자가 동일한 정보로 여러 번 등록할 수 있는지 여부',
          default: '닫기'
        },
        pass: {
          title: '등록 심사 통과:',
          hover: '사용자가 등록을 제출한 후, 시스템이 기본적으로 심사하여 등록이 유효/무효인지 여부를 결정할지 여부',
          default: '자동 통과',
          prepay: '먼저 심사 후 결제',
          postpay: '먼저 결제 후 심사'
        },
        show: {
          title: '등록 센터 표시:',
          hover: '개인: 한 사람의 정보를 입력할 때 등록; "팀": 여러 사람의 정보로 구성된 등록, 작품 공유',
          default: '표시'
        },
        form: {
          title: '그룹 등록 양식:',
          hover: '개인: 한 사람의 정보를 입력할 때 등록; "팀": 여러 사람의 정보로 구성된 등록, 작품 공유',
          default: '개인',
          team: '팀',
          min: '최소 팀 크기:',
          max: '최대 팀 크기:'
        },
        base: {
          title: '기본 평가 기능:',
          hover: '기본 평가 기능을 활성화할지 여부; 예: 활성화 또는 닫기',
          default: '닫기'
        },
        commission: {
          title: '파트너 수수료:',
          hover: '주최자의 하위 채널로서 파트너가 등록비의 수수료 비율을 설정',
          default: '닫기'
        },
        inherit: {
          title: '선정 번호 상속:',
          hover: '메인 메뉴의 고급 선정 관리에서 등록된 작품의 선정 번호를 설정할 수 있으며, 진출 시 다음 라운드로 번호를 상속할 수 있습니다',
          default: '닫기'
        }
      }
    },
    session: {
      title: '세션 정보',
      desc: '팁: 현재 세션 생성은 이전 단계에서 생성된 그룹 활동과만 연관됩니다. 여러 그룹 활동에 세션 배정이 있습니다. 먼저 활동의 초기 생성을 완료한 후 활동 관리에 들어가 "활동 설정 - 하위 대회 설정 - 세션 설정"을 클릭하여 설정하세요. 단일 그룹은 여러 세션을 생성할 수 있으며, 다른 그룹도 다른 세션을 생성할 수 있습니다.',
      name: '그룹 활동',
      number: {
        title: '등록자',
        hover: '등록자는 단일 세션에 대해 설정됩니다. 여러 세션이 있는 경우 각 세션의 참가자 수를 별도로 설정해야 합니다',
        config: '설정',
        default: '무제한'
      },
      arrange: {
        title: '세션 배정',
        hover: '관련 세션 배정이 아직 결정되지 않은 경우 닫을 수 있습니다; 이미 세션 배정이 있는 경우 열어서 설정할 수 있으며, 온라인과 오프라인을 지원합니다',
        default: '닫기'
      },
      form: '세션 형식:',
      online: '온라인 주소',
      offline: '지역 선택',
      address: '상세 주소',
      time: '세션 시간'
    }
  }
}



// WEBPACK FOOTER //
// ./src/langs/ko/activity.js